import { Vue, Component, Ref, Prop } from 'vue-property-decorator'
import { VRadio } from '@/types/vuetify/VRadio'

@Component({
  inheritAttrs: false,
})
export default class SRadioButton extends Vue {
  @Ref('radioButton') private readonly radioButtonRef?: VRadio
  @Prop({ type: Boolean }) private readonly active!: boolean

  private mounted() {
    this.$watch(
      () => {
        return this.active
      },
      (isActive) => {
        if (this.radioButtonRef) {
          this.radioButtonRef.isActive = isActive
        }
      },
      {
        immediate: true,
      }
    )
  }
}
